// extracted by mini-css-extract-plugin
export var simpleView = "recipe-preparation-steps-module--simple-view--6ad33";
export var stepItem = "recipe-preparation-steps-module--step-item--e3fc5";
export var stepList = "recipe-preparation-steps-module--step-list--24372";
export var steps = "recipe-preparation-steps-module--steps--9adc7";